import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { StatusBadge } from "@/components/StatusBadge";
import { relativeTime } from "@/lib/format";
import { toast } from "sonner";

const STATUSES = ["all", "open", "in_progress", "resolved", "closed"];
const PRIORITIES = ["all", "low", "normal", "high", "urgent"];

export default function SuperTickets() {
    const [tickets, setTickets] = useState([]);
    const [statusF, setStatusF] = useState("all");
    const [priorityF, setPriorityF] = useState("all");

    const load = async () => {
        const params = new URLSearchParams();
        if (statusF !== "all") params.set("status", statusF);
        if (priorityF !== "all") params.set("priority", priorityF);
        const { data } = await api.get(`/tickets?${params}`);
        setTickets(data);
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [statusF, priorityF]);

    const updateTicket = async (id, payload) => {
        try { await api.patch(`/tickets/${id}`, payload); await load(); }
        catch { toast.error("Failed"); }
    };

    return (
        <>
            <Topbar title="Support" subtitle={`${tickets.length} tickets`} />
            <div className="flex-1 overflow-auto p-6">
                <div className="mb-3 flex flex-wrap items-center gap-2">
                    <span className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">Status</span>
                    {STATUSES.map((s) => (
                        <button
                            key={s}
                            onClick={() => setStatusF(s)}
                            className={`rounded-md border px-2.5 py-1 text-[12px] font-medium capitalize ${statusF === s ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card hover:bg-muted/60"}`}
                            data-testid={`ticket-status-${s}`}
                        >{s.replace("_", " ")}</button>
                    ))}
                    <span className="ml-3 text-[11px] font-medium uppercase tracking-wider text-muted-foreground">Priority</span>
                    {PRIORITIES.map((s) => (
                        <button
                            key={s}
                            onClick={() => setPriorityF(s)}
                            className={`rounded-md border px-2.5 py-1 text-[12px] font-medium capitalize ${priorityF === s ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card hover:bg-muted/60"}`}
                        >{s}</button>
                    ))}
                </div>

                <div className="akm-card overflow-hidden">
                    <table className="akm-table w-full">
                        <thead><tr><th>Subject</th><th>Category</th><th>Priority</th><th>Status</th><th>Assignee</th><th>Created by</th><th>Updated</th><th></th></tr></thead>
                        <tbody>
                            {tickets.map((t) => (
                                <tr key={t.id}>
                                    <td className="font-medium">{t.subject}</td>
                                    <td className="capitalize text-muted-foreground">{t.category}</td>
                                    <td>
                                        <select value={t.priority} onChange={(e) => updateTicket(t.id, { priority: e.target.value })} className="akm-input h-7 w-[100px] text-[11px]">
                                            {["low", "normal", "high", "urgent"].map((p) => <option key={p}>{p}</option>)}
                                        </select>
                                    </td>
                                    <td>
                                        <select value={t.status} onChange={(e) => updateTicket(t.id, { status: e.target.value })} className="akm-input h-7 w-[120px] text-[11px]">
                                            {["open", "in_progress", "resolved", "closed"].map((p) => <option key={p}>{p}</option>)}
                                        </select>
                                    </td>
                                    <td className="font-mono text-[11px] text-muted-foreground">{t.assignee || "—"}</td>
                                    <td className="font-mono text-[11px] text-muted-foreground">{t.created_by_email || "—"}</td>
                                    <td className="text-muted-foreground">{relativeTime(t.updated_at)}</td>
                                    <td>
                                        {t.priority === "urgent" && <StatusBadge status="error" label="urgent" />}
                                    </td>
                                </tr>
                            ))}
                            {tickets.length === 0 && <tr><td colSpan="8" className="py-12 text-center text-muted-foreground">No tickets</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
